export function fromNowOn(d: Date) {
  const dayTime = 24 * 60 * 60 * 1000;
  const today = new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  const duration = +today - +d;

  if (duration < 0 && -duration <= dayTime) {
    return '今天';
  }
  if (duration > 0 && duration <= dayTime) {
    return '昨天';
  }
  // 2~7天显示n天前
  if (duration > dayTime && duration <= (7 * dayTime)) {
    return Math.ceil(duration / dayTime) + '天前';
  }
  // 超过一周直接显示年月日
  const year = d.getFullYear();
  const month = d.getMonth() + 1;
  const date = d.getDate();
  return `${year}.${month}.${date}`;
}

export function exceedDaysFromNow(d: Date) {
  const dayTime = 24 * 60 * 60 * 1000;
  const today = new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  const duration = +today - +d;
  return Math.ceil(duration / dayTime);
}
export function isOnOrAfterAugustFirst(date: Date | string | number = new Date()): boolean {
  const currentDate = new Date(date);
  if (Number.isNaN(currentDate.getTime())) {
    return false;
  }

  currentDate.setHours(0, 0, 0, 0);
  const augustFirst = new Date(currentDate.getFullYear(), 7, 1);
  augustFirst.setHours(0, 0, 0, 0);

  return currentDate.getTime() >= augustFirst.getTime();
}